import styled from 'styled-components';

export const Container = styled.div`
  padding: 36px 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 72px);
`;

export const ErrorImage = styled.img`
  height: 200px;
`;

export const ContainerMobile = styled.div<{ height: string }>`
  padding: 18px;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${props => props.height};
`;

export const ErrorImageMobile = styled.img`
  width: 90%;
  height: 200px;
  object-fit: contain;
`;

export const Content = styled.div`
  padding: 36px;
  border-radius: 18px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AvatarWrapper = styled.div`
  cursor: pointer;
`;

export const ContentMobile = styled.div`
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
